import { Box, Tooltip, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from './BloodTestResults.module.css'
import * as apiVitals from '../../services/ApiVitals'
import Loader from "../../components/Loader";

import { notifyError } from '../../components/NotifyToast'

import { IoArrowBackOutline } from "react-icons/io5";

import { config } from '../../config.env';

export default function BloodTestResults() {

    const navigate = useNavigate()
    const location = useLocation()

    const [loading, setLoading] = useState(false)
    const [dataBloodTest, setDataBloodTest] = useState([])

    useEffect(() => {
        findBloodTestResult()
    }, [])

    const findBloodTestResult = async () => {

        setLoading(true)

        let res = await apiVitals.getBloodTestResult();
        console.log(res);

        // MockUp
        if ((!res || !res['data']['status']) && !config.PRODUCTION)
        {
            console.log("Mockup BloodTestResults");
            res = {
                data: {
                    status: true,
                    data: [
                        {
                            "test_date": "2023-04-19T14:34:23.000Z",
                            "test_results": [
                                {
                                    "test_results": [
                                        {
                                            "result_name": "HDL",
                                            "result_value": 66,
                                            "result_unit": "mg/dL",
                                        },
                                        {
                                            "result_name": "Trig",
                                            "result_value": 216,
                                            "result_unit": "mg/dL",
                                        },
                                        {
                                            "result_name": "non-HDL",
                                            "result_value": 207,
                                            "result_unit": "mg/dL",
                                        },
                                        {
                                            "result_name": "HbA1c",
                                            "result_value": 5.9,
                                            "result_unit": "%",
                                        },
                                        {
                                            "result_name": "Creat",
                                            "result_value": 169.8,
                                            "result_unit": "mg/dL",
                                        },
                                    ],
                                }
                            ]
                        },
                        {
                            "test_date": "2023-06-16T14:20:11.000Z",
                            "test_results": [
                                {
                                    "test_results": [
                                        {
                                            "result_name": "HbA1c",
                                            "result_value": 6.6,
                                            "result_unit": "%",
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            };

            res.data.data.push(...res.data.data);
        }

        setLoading(false)

        if (res)
        {
            if (res['data']['status'] === true)
            {
                const results = res['data']['data'];

                const resultsN = results.length;
                const newResults = [];
                //for (let n=0; n<6; n++)
                //{
                    for (let i=0; i<resultsN; i++)
                    {
                        const result = results[i];
                        const tests = result['test_results'];
                        const testsN = tests.length;

                        // Map first to eliminate duplicate param/key
                        const data = {};
                        for (let j=0; j<testsN; j++)
                        {
                            const params = tests[j]['test_results'];
                            const paramsN = params.length;
                            for (let k=0; k<paramsN; k++)
                            {
                                const param = params[k];
                                const key = param['result_name'];
                                data[key] = param;
                            }
                        };

                        const keys = Object.keys(data);
                        const keysN = keys.length;
                        const dataset = [];
                        for (let j=0; j<keysN; j++)
                        {
                            const key = keys[j];
                            dataset.push({
                                name: key,
                                value: data[key]['result_value'],
                                unit: data[key]['result_unit'],
                            });
                        };
                        
                        newResults.push({
                            date: result['test_date'],
                            dataset: dataset
                        });
                    };
                //}

                setDataBloodTest(newResults);
            }
            else setDataBloodTest([])
        }
        else notifyError('ไม่ตอบสนอง')
    }

    const convertDate = (dataDate) => {
        const date = new Date(dataDate)
        const optionDate = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            timeZone: 'UTC',
        }

        const thaiLocale = 'th-TH';
        const formattedDate = date.toLocaleDateString(thaiLocale, optionDate)

        const newDate = `${formattedDate}`
        return newDate
    }

    return (<>

        <Loader loading={loading} />

        <Box sx={{
            color: '#263238',
            display: 'flex',
            flexDirection: 'column',
            gridGap: 20,
            fontSize: 18,
            margin: { xl: '2rem', lg: '2rem', md: '2rem', sm: '2rem', xs: '2rem 1rem' },
            '@media (max-width: 1023px)': {
                gridGap: '3%',
                fontSize: 16,
            },
            '@media (max-width: 800px)': {
                gridGap: '1%',
                fontSize: 14,
            },
            '@media (orientation: portrait)': {
                fontSize: '6vw',
            }
        }}>
            <Box sx={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr 1fr',
                mb:2,
                '@media (orientation: portrait)': {
                    gridTemplateColumns: '1fr 3fr 1fr',
                    '@media (min-width: 1000px)': {
                        m: '1em',
                    },
                }
            }}>

                <Box sx={{
                    display: 'flex',
                    justifyContent: 'start',
                    ml: '3rem',
                    '@media (orientation: portrait)': {
                        ml: 0,
                    }
                }}>
                    <Tooltip title="ย้อนกลับ">
                        <IconButton onClick={() => { navigate('/mainMenu') }} aria-label="Back" color="c_button" variant="resp">
                            <IoArrowBackOutline size='1.25em'/>
                        </IconButton>
                    </Tooltip>
                </Box>

                <Box sx={{
                    textAlign: 'center',
                    alignSelf: 'end',
                    color: 'c_title.main',
                    '@media (orientation: portrait)': {
                        alignSelf: 'center',
                    }
                }}
                >ผลตรวจเลือด</Box>

            </Box>
        </Box>

        <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            flexWrap: 'wrap',
            color: '#082C91',
            fontSize: '20px',
            mb: 2,
            '@media (orientation: portrait)': {
                flexDirection: 'column',
                alignContent: 'center',
                fontSize: '4vw',
            }
        }}>
            {dataBloodTest.length > 0 ?
                <Box sx={{
                    display: 'flex',
                    gridGap: 20,
                    mb:2, mx: 1,
                    alignItems: 'baseline',
                    '@media (orientation: landscape)': {
                        overflow: "hidden",
                        overflowX: "scroll",
                        scrollbarWidth: 'thin',
                    },
                    '@media (orientation: portrait)': {
                        flexDirection: 'column',
                        mx: 0,
                        width: '60vw',
                        alignItems: 'center'
                    } 
                }}>
                    {dataBloodTest.map((result, i) => (
                        <Box key={i}
                            sx={{
                                backgroundColor: '#E3E6F2',
                                borderRadius: '0.5em',
                                padding: '0.3em',
                                minWidth: '240px',
                                '@media (orientation: portrait)': {
                                    width: '60vw',
                                }
                            }}
                        >
                            <div className={styles.date} align='center' >{convertDate(result.date)}</div>
                            <Box sx={{
                                backgroundColor: '#FFFFFF',
                                borderRadius: '0.5em',
                                p: '1em',
                                alignContent:'center',
                                '@media (min-width: 500px)': {minHeight: '270px'}
                            }}>
                                { result.dataset.length > 1 ?
                                    result.dataset.map((param, j) => (
                                        <div className={styles.detail} key={j} >
                                            <div className={styles.resultName}>{param.name}</div>
                                            <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gridGap:'0.5em', paddingLeft:'0.5em'}}>
                                                <div className={styles.resultValue}>{param.value}</div>
                                                <div className={styles.resultUnit}>{param.unit}</div>
                                            </div>
                                        </div>
                                    ))
                                    :
                                    <div style={{display:'grid', gridTemplateColumns:'1fr', paddingTop:'1.9em', paddingBottom:'1.9em',}}>
                                        <div className={styles.resultName} style={{display:'block',  fontSize:'1.5em', textAlign:'center'}}>{result.dataset[0].name}</div>
                                        <div style={{textAlign:'center'}}>
                                            <div className={styles.resultValue} style={{fontSize:'2em', lineHeight:'1em'}}><b>{result.dataset[0].value + " "}</b></div>
                                            <div className={styles.resultUnit} style={{fontSize:'1.5em'}}>{result.dataset[0].unit}</div>
                                        </div>
                                    </div>
                                }
                            </Box>
                        </Box>
                    ))}
                </Box>
                :
                <div style={{ textAlign: 'center', margin: '20%', fontSize: '1.25em' }}>ไม่พบข้อมูล</div>
            }
        </Box>
    </>)
}
